module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-regular.5cc3aae6.woff";